var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",attrs:{"id":"modalTitle"}},[_c('div',{staticClass:"divHeader",on:{"click":_vm.close}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('strong',[_vm._v("X")])])
}]

export { render, staticRenderFns }